import Sidebar from "./SideBar.vue";
import SidebarItem from "./SidebarItem.vue";
import SidebarToggle from "./SidebarToggle.vue";

const SidebarStore = {
  showSidebar: false,
  sidebarLinks: [],
  linksStore: [],
  isMinimized: false,
  isExpanded: false,
  displaySidebar(value) {
    this.showSidebar = value;
  },
  toggleMinimize() {
    document.body.classList.toggle("sidebar-mini");

    // Controlar el estado expandido
    if (document.body.classList.contains("sidebar-mini")) {
      this.isExpanded = false;
      // Remover clase de expansión del sidebar
      const sidebar = document.querySelector(".sidebar");
      if (sidebar) {
        sidebar.classList.remove("sidebar-expanded");
      }
    } else {
      this.isExpanded = true;
      // Agregar clase de expansión al sidebar
      const sidebar = document.querySelector(".sidebar");
      if (sidebar) {
        sidebar.classList.add("sidebar-expanded");
      }
    }

    // we simulate the window Resize so the charts will get updated in realtime.
    const simulateWindowResize = setInterval(() => {
      window.dispatchEvent(new Event("resize"));
    }, 180);

    // we stop the simulation of Window Resize after the animations are completed
    setTimeout(() => {
      clearInterval(simulateWindowResize);
    }, 1000);

    this.isMinimized = !this.isMinimized;
  },
  toggleExpanded() {
    this.isExpanded = !this.isExpanded;
    const sidebar = document.querySelector(".sidebar");
    if (sidebar) {
      if (this.isExpanded) {
        sidebar.classList.add("sidebar-expanded");
        document.body.classList.remove("sidebar-mini");
      } else {
        sidebar.classList.remove("sidebar-expanded");
        document.body.classList.add("sidebar-mini");
      }
    }

    // Simular resize para actualizar gráficos
    const simulateWindowResize = setInterval(() => {
      window.dispatchEvent(new Event("resize"));
    }, 180);

    setTimeout(() => {
      clearInterval(simulateWindowResize);
    }, 1000);
  },
  addSidebarLink(link) {
    this.linksStore.push(link);
  },
  removeSidebarLink(link) {
    const index = this.linksStore.indexOf(link);
    if (index >= 0) this.linksStore.splice(index, 1);
  },
  collapseAllMenus() {
    this.linksStore.forEach((link) => {
      link.collapsed = true;
    });
  },
};

const SidebarPlugin = {
  install(Vue, options) {
    if (options && options.sidebarLinks) {
      SidebarStore.sidebarLinks = options.sidebarLinks;
    }
    Vue.mixin({
      data() {
        return {
          sidebarStore: SidebarStore,
        };
      },
    });

    Object.defineProperty(Vue.prototype, "$sidebar", {
      get() {
        return this.$root.sidebarStore;
      },
    });
    Vue.component("side-bar", Sidebar);
    Vue.component("sidebar-item", SidebarItem);
    Vue.component("sidebar-toggle", SidebarToggle);
  },
};

export default SidebarPlugin;
